document.addEventListener('DOMContentLoaded', function () {
    document.getElementById('nav_el_1').addEventListener('click', function() {
        document.querySelector('#nav_el_2 svg').style.transform = 'rotate(360deg)';
        document.querySelector('#nav_el_1 svg').style.transform = 'rotate(180deg)';
        openMainNavigation('shop_all_submenu');
    }, false);
    document.getElementById('nav_el_2').addEventListener('click', function() {
        document.querySelector('#nav_el_1 svg').style.transform = 'rotate(360deg)';
        document.querySelector('#nav_el_2 svg').style.transform = 'rotate(180deg)';
        openMainNavigation('recipes_submenu');
    }, false);
    document.getElementById('menu-overflow').addEventListener('click', function() {
        closeMainNavigation();
        document.querySelector('#nav_el_1 svg').style.transform = 'rotate(360deg)';
        document.querySelector('#nav_el_2 svg').style.transform = 'rotate(360deg)';
    }, false);

    document.getElementById('open-mobile-nav').addEventListener('click', function() {
        openMainNavigationMobile();

    }, false);

    document.getElementById('close-mobile-nav').addEventListener('click', function() {
        closeMainNavigationMobile();

    }, false);

    let url_hash = window.location.hash;
    let url_hash_filtered = url_hash.substring(6);

    if(url_hash_filtered != '') {
        const options = document.querySelectorAll(`option[value="${url_hash_filtered}"]`);
        options.forEach(option => {
            option.selected = true;
        });
        openAccountMenu(url_hash_filtered, 0);
    }else{
        const options = document.querySelectorAll('option[value="recipe_box"]');
        options.forEach(option => {
            option.selected = true;
        });
    }

    if(url_hash=='#order'){
        openAccountMenu('account_orders', 0);
    }

    let elResult = document.getElementById('searchinput');
    elResult.addEventListener('keyup', searchResults);

    let currentUrl= new URL(document.location.href);
    let find_login_modal = currentUrl.searchParams.get("login_modal");
    if(find_login_modal == '1') {
        openLoginModal();
    }
    let find_activate_customer = currentUrl.searchParams.get("activate_customer");
    if(find_activate_customer == '1') {
        openLoginModal();
        openResendActivationModal();
    }

	 // Desktop Menu
	document.querySelectorAll(".submenu-button").forEach(button => {
		button.addEventListener("click", function () {
			 const isActive = this.classList.contains("active"); // Check if button is already active

			 // Remove active class from all buttons and submenu lists
			 document.querySelectorAll(".submenu-button").forEach(btn => btn.classList.remove("active"));
			 document.querySelectorAll(".submenu-list").forEach(submenu => submenu.classList.remove("active"));

			 // If it wasn't active before, add the active class
			 if (!isActive) {
				  this.classList.add("active");
				  const submenu = this.nextElementSibling;
				  if (submenu && submenu.classList.contains("submenu-list")) {
						submenu.classList.add("active");
				  }
			 }
		});
  });

	//  Mobile Menu
	const submenuButtons = document.querySelectorAll(".submenu-mobile-button");

    submenuButtons.forEach(button => {
        button.addEventListener("click", function () {
            const submenuSlide = this.closest(".submenu-mobile-slide");
            const submenuTopTitle = document.querySelector(".submenu-mobile-top-title");
            const allSubmenus = document.querySelectorAll(".submenu-mobile-slide");

            if (submenuSlide.classList.contains("active")) {
                // If already active, remove active and show other hidden submenus
                submenuSlide.classList.remove("active");
                submenuTopTitle.classList.remove("hidden");

                allSubmenus.forEach(slide => {
                    slide.classList.remove("hidden");
                });
            } else {
                // Hide all other submenu slides and add hidden class
                allSubmenus.forEach(slide => {
                    slide.classList.remove("active");
                    slide.classList.add("hidden");
                });

                // Hide top title
                submenuTopTitle.classList.add("hidden");

                // Show the clicked submenu
                submenuSlide.classList.add("active");
                submenuSlide.classList.remove("hidden");
            }
        });
    });


}, false);

function searchActionForMobile() {
    let search_w = document.getElementById('searchinput_mobile').value;
    if(search_w.length>0) {
        goToViewAllSearch('all', search_w);
    }
}

function searchResults() {
    let search_w = this.value;
    let w_length = search_w.length;
    let new_width = 15;
    const search_line_element = document.getElementById('search_word_line');
    const search_result_block = document.getElementById('search-results');
    const search_black_icon = document.getElementById('search_black_icon');
    const search_cancel = document.getElementById('search_cancel');
    const main_search_inner = document.getElementById('main_search_inner');

    if (w_length > 0) {
        new_width = w_length * 22;

        let xhr = new XMLHttpRequest();
        xhr.open('GET', '/search?type=product,article&view=json&q=' + search_w + '&prefix=last', true);

        xhr.onload = function () {
            if (xhr.status === 200) {
                var dataHTML = xhr.responseText;
                search_result_block.innerHTML = dataHTML;
                CDE_init_save_to_favorites();
            }
        };

        xhr.send();

        search_result_block.style.display = 'block';
        search_line_element.style.display = 'inline-block';
        search_black_icon.style.display = 'none';
        search_cancel.style.display = 'inline-block';
        main_search_inner.style.height = '100vh';

    }else{
        search_result_block.style.display = 'none';
        search_line_element.style.display = 'none';
        search_black_icon.style.display = 'inline-block';
        search_cancel.style.display = 'none';
        main_search_inner.style.height = 'unset';
    }
    animateSearchLine(new_width, search_line_element);
}

function animateSearchLine(new_width, element) {
    const targetWidth = new_width;
    const duration = 120;
    const fps = 60;

    const frameDuration = 1000 / fps;
    const totalFrames = Math.ceil(duration / frameDuration);
    const stepWidth = (targetWidth - element.offsetWidth) / totalFrames;

    let currentFrame = 0;

    function animate() {
        if (currentFrame < totalFrames) {
            currentFrame++;
            const newWidth = element.offsetWidth + stepWidth;
            element.style.width = `${newWidth}px`;
            requestAnimationFrame(animate);
        }
    }

    animate();
}

function cancelSearch() {
    const search_line_element = document.getElementById('search_word_line');
    const search_result_block = document.getElementById('search-results');
    const search_black_icon = document.getElementById('search_black_icon');
    const search_cancel = document.getElementById('search_cancel');
    const searchInput = document.getElementById('searchinput');
    const main_search_inner = document.getElementById('main_search_inner');

    search_result_block.style.display = 'none';
    search_line_element.style.display = 'none';
    search_black_icon.style.display = 'inline-block';
    search_cancel.style.display = 'none';
    searchInput.value = '';
    main_search_inner.style.height = 'unset';
}

function goToViewAllSearch(filter, search_w) {
    if(search_w == '') {
        search_w = document.getElementById('searchinput').value;
    }
    if(filter!='') {
        document.location.href = '/search?type=product,article&q=' + search_w + '&prefix=last&filter=' + filter;
    }else{
        document.location.href = '/search?type=product,article&q=' + search_w + '&prefix=last';
    }
}

function openSearchModal() {
    document.getElementById('bg-opacity-search').style.display = 'block';
    document.getElementById('modal-search').style.display = 'block';
    document.getElementById('open_search_modal').style.display = 'none';
    document.getElementById('close_search_modal').style.display = 'inline-block';
    document.querySelector('body').style.overflow = 'hidden';
    document.getElementById('searchinput').focus();
}

function closeSearchModal() {
    document.getElementById('bg-opacity-search').style.display = 'none';
    document.getElementById('modal-search').style.display = 'none';
    document.getElementById('open_search_modal').style.display = 'inline-block';
    document.getElementById('close_search_modal').style.display = 'none';
    document.querySelector('body').style.overflow = 'auto';
}

function openMainNavigationMobile() {
    document.getElementById('mobile-nav').style.display = 'block';
    document.getElementById('close-mobile-nav').style.display = 'block';
    document.getElementById('open-mobile-nav').style.display = 'none';
    closeSmallCart();
	 document.querySelector('body').style.overflow = 'hidden';
}

function closeMainNavigationMobile() {
    document.getElementById('mobile-nav').style.display = 'none';
    document.getElementById('close-mobile-nav').style.display = 'none';
    document.getElementById('open-mobile-nav').style.display = 'block';
    document.querySelector('body').style.overflow = 'auto';
}

function openMobileSubmenu(menu_counter) {
    document.getElementById('mobile-main-menu').style.display = 'none';
    document.getElementById(`mobile-submenu-${menu_counter}`).style.display = 'block';
}

function closeMobileSubmenu() {
    document.getElementById('mobile-main-menu').style.display = 'block';
    document.getElementById('mobile-submenu-1').style.display = 'none';
    document.getElementById('mobile-submenu-2').style.display = 'none';
}

function openMainNavigation(menu_id) {
    closeSearchModal();
    if(document.getElementById(`${menu_id}`).style.display == 'none') {
        closeMainNavigation();
        document.getElementById(`${menu_id}`).style.display = 'block';
        document.getElementById('menu-overflow').style.display = 'block';
      //   document.querySelector('body').style.overflow = 'hidden';
    }else{
        closeMainNavigation();
        document.querySelector('#nav_el_1 svg').style.transform = 'rotate(360deg)';
        document.querySelector('#nav_el_2 svg').style.transform = 'rotate(360deg)';
    }
}

function closeMainNavigation() {
    document.getElementById('shop_all_submenu').style.display = 'none';
    document.getElementById('recipes_submenu').style.display = 'none';
    document.getElementById('menu-overflow').style.display = 'none';
    document.querySelector('body').style.overflow = 'auto';
}

function hideAllModalContainers() {
    let modalContainers = document.querySelectorAll('.modal-container');
    modalContainers.forEach(function(container) {
        container.style.display = 'none';
    });
}

function hideAllAccountBlocks() {
    let modalContainers = document.querySelectorAll('.account-block');
    modalContainers.forEach(function(container) {
        container.style.display = 'none';
    });

    let accountMainMenu = document.querySelectorAll('.account-main-menu');
    accountMainMenu.forEach(function(container) {
        container.classList.remove("active-account-menu");
    });
}

function hideAccountSubmenu() {
    let containerBlock = document.querySelectorAll('.extra-account-block');
    containerBlock.forEach(function(container) {
        container.style.display = 'none';
    });
}

function showAccountSubmenu() {
    let containerBlock = document.querySelectorAll('.extra-account-block');
    containerBlock.forEach(function(container) {
        container.style.display = 'grid';
    });
}

function openSignUpModal() {
    hideAllModalContainers();
    document.getElementById('signup_modal_content').style.display = 'block';
}

function openSignInModal() {
    hideAllModalContainers();
    document.getElementById('signin_modal_content').style.display = 'block';
}

function openForgotModal() {
    hideAllModalContainers();
    document.getElementById('restore_modal_content').style.display = 'block';
}

function openResendActivationModal() {
    hideAllModalContainers();
    document.getElementById('resendactivation_modal_content').style.display = 'block';
}

function closeLoginModal() {
    document.getElementById('login_modal').style.display = 'none';
}

function openLoginModal() {
    closeMainNavigationMobile();
    closeSearchModal();
    document.getElementById('login_modal').style.display = 'block';
}

function openSizeGuideModal() {
    document.getElementById('modal-size-guide').style.display = 'block';
}

function closeSizeGuideModal() {
    document.getElementById('modal-size-guide').style.display = 'none';
}

function openAccountMenu(account_block, open_new_page) {
    if(open_new_page == 1) {
        document.location.href='/account#page='+account_block;
    }else {
        hideAllAccountBlocks();
        document.getElementById(account_block).style.display = 'block';
        document.getElementById(`menu_${account_block}`).classList.add("active-account-menu");
        window.location.hash = 'page=' + account_block;
        return false;
    }
}

function openAccountMenuMobile(account_block, open_new_page, membership_url) {
    if(account_block == 'subscribe') {
        document.location.href='/a/account/shopify-login';
    }else if(account_block == 'membership') {
        document.location.href = membership_url;
    }else{
        if (open_new_page == 1) {
            document.location.href = '/account#page=' + account_block;
        } else {
            hideAllAccountBlocks();
            document.getElementById(account_block).style.display = 'block';
            document.getElementById(`menu_${account_block}`).classList.add("active-account-menu");
            window.location.hash = 'page=' + account_block;
            return false;
        }
    }
}

function openAccountEditPage() {
    hideAllAccountBlocks();

    const selectElement = document.querySelector('#account_menu_mobile');
    const optionToSelect = selectElement.querySelector('option[value="not_selected"]');
    if (optionToSelect) {
        optionToSelect.selected = true;
    }

    document.getElementById('account_edit').style.display = 'grid';
}


